document.addEventListener('DOMContentLoaded', function () {


    function slideToggle(el, duration = 300) {
        const isHidden = getComputedStyle(el).display === "none";
        if (isHidden) slideDown(el, duration);
        else slideUp(el, duration);
    }

    function slideUp(el, duration = 300) {
        if (el._slideTimer) clearTimeout(el._slideTimer);

        // If it's already hidden, nothing to do
        if (getComputedStyle(el).display === "none") return;

        // Lock current height (important for interrupting mid-animation)
        el.style.overflow = "hidden";
        el.style.height = el.offsetHeight + "px";
        el.offsetHeight; // reflow

        el.style.transitionProperty = "height";
        el.style.transitionDuration = duration + "ms";
        el.style.height = "0px";

        el._slideTimer = setTimeout(() => {
            el.style.display = "none";
            cleanup(el);
        }, duration);
    }

    function slideDown(el, duration = 300) {
        if (el._slideTimer) clearTimeout(el._slideTimer);

        // Make it measurable
        el.style.removeProperty("display");
        let display = getComputedStyle(el).display;
        if (display === "none") display = "block";
        el.style.display = display;

        el.style.overflow = "hidden";
        el.style.height = "0px";
        el.offsetHeight; // reflow

        // Measure *now* (works even if unpredictable)
        const target = el.scrollHeight;

        el.style.transitionProperty = "height";
        el.style.transitionDuration = duration + "ms";
        el.style.height = target + "px";

        el._slideTimer = setTimeout(() => {
            // Let it grow/shrink naturally after it's open
            el.style.removeProperty("height");
            el.style.removeProperty("overflow");
            el.style.removeProperty("transition-property");
            el.style.removeProperty("transition-duration");
        }, duration);
    }

    function cleanup(el) {
        el.style.removeProperty("height");
        el.style.removeProperty("overflow");
        el.style.removeProperty("transition-property");
        el.style.removeProperty("transition-duration");
    }


    var wrappersAccordions = document.querySelectorAll('.wp-block-plblockstt-faq-category');

    if (wrappersAccordions) {
        wrappersAccordions.forEach(function (item) {
            item.querySelector('.accordionTitle').addEventListener('click', function () {
                item.querySelector('.accordionTitle').classList.toggle('open');
                slideToggle(item.querySelector('.accordionTitle').nextElementSibling);
            });
        });
    }
});